export default __webpack_public_path__ + "static/media/1480.7d04f822.gif";